import React from "react";
import { AppDialog } from "../ui";

type HostSpotUnavailableDialogProps = {
  visible: boolean;
  onHide: () => void;
  /** Lugares ya tomados por inscriptos y sus invitados. */
  occupiedSpots: number;
  /** Cupos totales que tiene el formulario en este momento. */
  totalSpots: number;
  /**
   * No se pudo traer la lista de inscriptos, así que quedó sin confirmar si el
   * host ya tiene inscripción propia —el único caso en que el toggle no
   * consumiría un cupo nuevo—. Se aclara en vez de afirmar algo no verificado.
   */
  registrationCheckFailed?: boolean;
};

/**
 * GTK-717 / TC-PAY-15. El host que participa se inscribe y ocupa un cupo, así que
 * sobre un evento sin lugares el toggle dejaría más inscriptos confirmados que
 * cupos. Producto decidió no desplazar a ningún asistente ya confirmado: se avisa
 * que no hay lugar y "Host participa en el evento" queda sin activar.
 */
const HostSpotUnavailableDialog: React.FC<HostSpotUnavailableDialogProps> = ({
  visible,
  onHide,
  occupiedSpots,
  totalSpots,
  registrationCheckFailed = false,
}) => (
  <AppDialog
    variant="detail"
    header="No hay cupos para el host"
    visible={visible}
    onHide={onHide}
  >
    {/* Se enuncian los dos números por separado en vez de "X de Y ocupados":
        `totalSpots` sale del formulario y puede ser menor que los ocupados, o 0
        mientras se reescribe el campo, y ahí la forma "X de Y" se leería mal. */}
    <p className="mt-0">
      Hay <strong>{occupiedSpots}</strong>{" "}
      {occupiedSpots === 1 ? "lugar ocupado" : "lugares ocupados"} y los cupos
      totales son <strong>{totalSpots}</strong>.
    </p>
    <p className={registrationCheckFailed ? "" : "mb-0"}>
      El host ocupa un cupo cuando participa, así que no entra sin desplazar a
      alguien ya inscripto. Ampliá los cupos totales o dá de baja una inscripción,
      y volvé a intentarlo.
    </p>
    {registrationCheckFailed && (
      <p className="mb-0">
        Tampoco pudimos verificar si el host ya tiene una inscripción propia, que
        es el único caso en que activarlo no ocuparía un lugar nuevo. Si creés que
        la tiene, recargá la página e intentá de nuevo.
      </p>
    )}
  </AppDialog>
);

export default HostSpotUnavailableDialog;
